// ----POPULAR SEARCHES-----
export const GET_POPULAR_CONTENT = 'GET_POPULAR_CONTENT';
export const POPULAR_ADD_BOOKMARK_LIVE = 'POPULAR_ADD_BOOKMARK_LIVE';

//----SEARCH ACTIONS----
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const GET_POPULAR_SEARCHES = 'GET_POPULAR_SEARCHES';
export const NOT_FOUND_SEARCH_RESULTS = 'NOT_FOUND_SEARCH_RESULTS';
export const SEARCH_ADD_BOOKMARK_LIVE = 'SEARCH_ADD_BOOKMARK_LIVE';

//-----SETEAR KEYWORD
export const SET_KEYWORD_SEARCH = 'SET_KEYWORD_SEARCH';
export const CLEAR_KEYWORD_SEARCH = 'CLEAR_KEYWORD_SEARCH';

//----LIVE MENU ACTIONS----
export const SET_LIVE_MENU_OPTIONS = 'SET_LIVE_MENU_OPTIONS';
export const SEARCH_CLEAR_LIVE_MENU_OPTIONS = 'SEARCH_CLEAR_LIVE_MENU_OPTIONS';

//----MULTI CONTENT SEARCH----
export const GET_MCS_PLAY_BUTTON_LIST = 'GET_MCS_PLAY_BUTTON_LIST';
export const GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES = 'GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES'
export const CLEAR_MCS_PLAY_BUTTON_LIST = 'CLEAR_MCS_PLAY_BUTTON_LIST';

//----TALENT ACTIONS----
export const SET_TALENT_INFO = "SET_TALENT_INFO";
export const CLEAR_TALENT_INFO = "CLEAR_TALENT_INFO";

//----IS LOADING RESULTS----
export const IS_LOADING_SEARCH = 'IS_LOADING_SEARCH';

//----TALENT ACTIONS FROM VCARD----
export const SET_TALENT_INFO_VCARD = "SET_TALENT_INFO_VCARD";
export const CLEAR_TALENT_INFO_VCARD = "CLEAR_TALENT_INFO_VCARD";

//SET ERRORS
export const SET_ERROR_SEARCH = 'SET_ERROR_SEARCH';